// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"6a1794d4","453":"c50316e8","455":"9c953517","977":"0848f80d"}[chunkId] + ".chunk.js";
};